import { useEffect, useState } from 'react';
import { NomineeAgent } from '@features/api/response/NomineeAgent';

export interface FilterCriteria {
  name?: string;
  email?: string;
}

export const useNomineeAgentsFilter = (initialAgents: NomineeAgent[]) => {
  const [filteredData, setFilteredData] = useState<NomineeAgent[]>([
    ...initialAgents,
  ]);

  const [filterCriteria, setFilterCriteria] = useState<FilterCriteria>();
  const [isSearchButtonEnabled, setIsSearchButtonEnabled] =
    useState<boolean>(true);

  useEffect(() => {
    if (initialAgents.length > 0) {
      setFilteredData(() => [...initialAgents]);
    }
  }, [initialAgents]);

  const handleFilterChange = (value: string, key: keyof FilterCriteria) => {
    setFilterCriteria({ ...filterCriteria, [key]: value });
    setIsSearchButtonEnabled(true);
  };

  const handleNameFilterChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const value = e.currentTarget.value;
    handleFilterChange(value, 'name');
  };

  const handleEmailFilterChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const value = e.currentTarget.value;
    handleFilterChange(value, 'email');
  };

  const filterData = () => {
    let filteredDataTemp = [...initialAgents];

    if (filterCriteria?.name) {
      filteredDataTemp = filteredDataTemp.filter((x) =>
        x.name
          .toLowerCase()
          .includes((filterCriteria.name ?? '_').toLowerCase())
      );
    }
    if (filterCriteria?.email) {
      filteredDataTemp = filteredDataTemp.filter((x) =>
        x.email
          .toLowerCase()
          .includes(filterCriteria.email ?? '_'.toLowerCase())
      );
    }

    setFilteredData(filteredDataTemp);
  };

  const handleSearchButtonClick = () => {
    filterData();
    setIsSearchButtonEnabled(false);
  };

  const handleClearButtonClick = () => {
    setFilterCriteria({});
    setFilteredData([...initialAgents]);
  };

  return {
    values: {
      filterCriteria,
      filteredData,
      isSearchButtonEnabled,
    },
    handlers: {
      handleNameFilterChange,
      handleEmailFilterChange,
      handleSearchButtonClick,
      handleClearButtonClick,
    },
  };
};
